export default {
  background: "#FFFFFF",
  backgroundSecondary: "#F2F2F1",
  blue: "#60A0D8",
  black: "#333",
  darkBlue: "#323F4F",
  gray: "#979797",
  green: "#00B245",
  inactive: "#D3CFCF",
  lightestGray: "#fafafa",
  lightGray: "#ececec",
  red: "#C4221F",
  orange: "#FF9D2E",
  primary: "#00739D",
  purple: "#986091",
  secondary: "#65C6C4",
  teal: "#4AC8A7",
  textBlue: "#2BA7DB",
  textGray: "#938E8E",
  textSecondary: "#797575",
  white: "#fff"
};
